import RequirementTypeContainer from "./RequirementTypeContainer";
export default RequirementTypeContainer;
